export { PaymentTypesModule } from "./PaymentTypesModule";
